import * as React from 'react';

interface IDownloadIcon {
  className?: string;
}

export function DownloadIcon(props: IDownloadIcon) {
  const className = props.className && '';

  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" width="10" height="13" viewBox="0 0 10 13">
      <path
        fill="currentColor"
        d="M9 5H6.333V.7a.7.7 0 0 0-.7-.7H4.367a.7.7 0 0 0-.7.7V5H1l4 4.755L9 5zM.7 13h8.6a.7.7 0 0 0 .7-.7v-.6a.7.7 0 0 0-.7-.7H.7a.7.7 0 0 0-.7.7v.6a.7.7 0 0 0 .7.7z"
      />
    </svg>
  );
}
